import { createApp } from "vue";
import "./index.css";
import App from "./App.vue";
import router from "./router";
import { createI18n } from 'vue-i18n';
import idiomaService from "./services/idioma.services";

// Instncia aca los token
import '@/services/suite.config';

// Theme assets
import "./assets/css/nucleo-icons.css";
import "./assets/css/nucleo-svg.css";
// @ts-ignore
import SoftUIDashboard from "./soft-ui-dashboard";
// import store from "./store";

// i18n
import en from '@/locales/en.json';
import es from '@/locales/es.json';

// PrimeVue
import PrimeVue from "primevue/config";
import Aura from "@primevue/themes/aura";
// PrimeVue Icons
import 'primeicons/primeicons.css'

import Tooltip from 'primevue/tooltip';

// Font Awesome
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
library.add(fas);
library.add(fab);
library.add(far);

const idiomaSeleccionado: string = idiomaService.getIdiomaSeleccionado() as string;

const i18n = createI18n({
  legacy: false,
  locale: idiomaSeleccionado,
  fallbackLocale: idiomaSeleccionado,
  globalInjection: true,
  messages: {
    en: en,
    es: es
  }
});

// App configuration
const app = createApp(App);
app.use(i18n);
app.use(router);
app.use(SoftUIDashboard);
app.directive('tooltip', Tooltip);
app.use(PrimeVue, {
  theme: {
    preset: Aura,
    options: {
      dark: false, // Desactiva el modo oscuro
      darkModeSelector: 'none' 
    }
  }
});
app.component("font-awesome-icon", FontAwesomeIcon);
app.mount("#app");
